import gql from "graphql-tag";
import { useMutation } from "@apollo/react-hooks";
import { COMMENTS_QUERY } from "../useComments";

const ADD_COMMENT = gql`
  mutation addComment($workId: String!, $comment: String!, $parentId: String) {
    addComment(workId: $workId, comment: $comment, parentId: $parentId) {
      id
      userId
      workId
      comment
      createdAt
      canDelete
      canReply
      canReport
      user {
        id
        userName
        displayName
        avatar
      }
      commentReplies {
        id
        userId
        workId
        comment
        createdAt
        canDelete
        canReply
        canReport
        user {
          id
          userName
          displayName
          avatar
        }
      }
    }
  }
`;

const updateCommentsCache = (proxy, data, { parentId, workId }) => {
  const commentsCache = proxy.readQuery({
    query: COMMENTS_QUERY,
    variables: { workId },
  });

  const cachedComments = commentsCache.comments;
  let newCache;
  const newComment = data.addComment;

  if (parentId) {
    const parent = cachedComments.find((x) => x.id === parentId);
    parent.commentReplies.push(newComment);
    newCache = cachedComments;
  } else {
    newCache = [newComment, ...cachedComments];
  }

  proxy.writeQuery({
    query: COMMENTS_QUERY,
    variables: { workId },
    data: {
      ...commentsCache,
      comments: newCache,
    },
  });
};

const useAddComment = () => {
  const [ac, { data: result, loading, error }] = useMutation(ADD_COMMENT);

  const addComment = async (variables) => {
    return ac({
      variables,
      update: (proxy, { data }) => {
        updateCommentsCache(proxy, data, variables);
      },
    });
  };

  return {
    addComment,
    addCommentLoading: loading,
    addCommentError: error,
    addCommentResult: result,
  };
};

export { useAddComment };
